import memoize from 'fast-memoize';
import { createSelector } from 'reselect';

import { State } from '../Store';

export const selectManufacturers = (state: State) => state.manufacturers || [];

export const selectLocation = memoize((id: number | null) =>
  id
    ? createSelector(
        [selectManufacturers],
        manufacturers =>
          manufacturers.find(manufacturer => manufacturer.id === id)
      )
    : () => undefined
);
